import apiService from './apiService'
import * as _ from 'lodash'

var servidorService = _.clone(apiService)

servidorService.endpoint = '/servidor'

export default servidorService



// WEBPACK FOOTER //
// ./src/services/servidores.js